module.exports = __webpack_public_path__ + "static/zeroswap-9966c33dd72d4a6d47c67fe7b1b3bb35.png";